export default __webpack_public_path__ + "static/media/AdamPerron.4cde6c10.jpeg";